import { Badge, FormHelperText, Menu, MenuItem, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { LoadOrgName } from "../../actions";
import Config from "../../config";
import { setHeaderTitle } from "../../helpers/header.helper";
import { ProfileModel } from "../../models/profile.model";
import { Role } from "../../models/roles.model";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import Avatar from "../shared/avatar.component";
import ButtonComponent from "../shared/button/button.component";
import { ActionLabels, pageTitles, RolesLabel, ToasterTexts } from "../shared/constants";
import PageHeader from "../shared/page-header.component";
import { useDispatch, useSelector } from "react-redux";
import PullToRefresh from 'react-simple-pull-to-refresh';
import setToast from "../../helpers/toaster.helper";
import { BackMobileIcon, ChangeProfileIcon, EditProfileIcon, ProfileImageIcon, RemoveIcon, RemovePhotoIcon, UploadIcon } from "../../icon";
import * as selector from "../../selectors/selectors";
import { validateForm } from "../shared/form-validation";
import { ToasterType } from "../shared/toaster/toaster.model";

interface Props {
	IsMobileDevice: boolean;

}

const ProfileComponent = (props: Props) => {
	const dispatch = useDispatch()
	const fileInputRef = useRef<HTMLInputElement>()
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const [Profile, setProfile] = useState<ProfileModel>(UserService.getCurrentUserFromLocalStorage())
	const OrgName = useSelector(selector.OrganizationName);
	const LoadingProfile: boolean = useSelector(selector.loadingProfile)
	const IsDarkMode: boolean = useSelector(selector.isDarkMode)
	const [showEditProfile, setShowEditProfile] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [firstName, setFirstName] = useState(Profile.FirstName);
	const [lastName, setLastName] = useState(Profile.LastName);
	const [file, setFile] = useState("");
	const [imageCleared, setImageCleared] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [imageReferenceId, setImageReferenceId] = useState(Profile.ImageReferenceId);
	const [image, setImage] = useState(
		Profile.ImageReferenceId
			? `${Config.API_URL}/api/File/${Profile.ImageReferenceId}/view`
			: ""
	);
	const [hasError, setHasError] = useState("");
	const [errors, setErrors] = useState({
		FirstName: "",
		LastName: "",
	});

	useEffect(() => {
		LoadOrgName(dispatch, Profile.OrgId);
		setHeaderTitle(pageTitles.PROFILE)
	}, [])

	const handleOpenEditProfile = () => {
		setShowEditProfile(true)
		setFirstName(Profile.FirstName)
		setLastName(Profile.LastName)
		setImage(Profile.ImageReferenceId ? `${Config.API_URL}/api/File/${Profile.ImageReferenceId}/view` : null);
	};

	const handleCloseEditProfile = (flag: boolean) => {
		setShowEditProfile(false)
		setHasError("");
		setImage(Profile.ImageReferenceId ? `${Config.API_URL}/api/File/${Profile.ImageReferenceId}/view` : null)
		setErrors({ ...errors, FirstName: "", LastName: "" })
		if (flag) {
			UserService.getCurrentUser().then((res) => {
				setProfile(UserService.getCurrentUserFromLocalStorage())
				setImage(res.data.ImageReferenceId ? `${Config.API_URL}/api/File/${Profile.ImageReferenceId}/view` : image)
			}).catch((er) => {
			})
			LoadOrgName(dispatch, Profile.OrgId);
		}
	};
	const handleChange = (name: any, value: any) => {
		validateForm({ [name]: value }, (Errors) => {
			setErrors({ ...errors, ...Errors })
		});
	};


	const handleClickmenu = (event: any) => {
		event.preventDefault();
		setAnchorEl(event.target)
	};

	const handleClosemenu = () => {
		setAnchorEl(null)
	};


	const onSubmit = (event: any) => {
		event.preventDefault();
		if (
			validateForm(
				{ FirstName: firstName, LastName: lastName },
				(Errors) => {
					setErrors({ ...errors, ...Errors })
				}
			)
		) {
			setIsLoading(true)
			var formData = new FormData();
			formData.append("FirstName", firstName.trim());
			formData.append("LastName", lastName.trim());
			formData.append("imageFile", file);
			UserService.changeProfile(formData, imageCleared)
				.then((res) => {
					setIsLoading(false)
					setToast(ToasterTexts.PROFILE_EDIT_SUCCESS, ToasterType.SUCCESS);
					handleCloseEditProfile(true);
				})
				.catch((err) => setIsLoading(false))
		} else {
		}
	}

	const onImagechange = (e: any) => {
		let file = e.target.files[0];
		setHasError("")
		if (file) {
			const Url = URL.createObjectURL(file);
			const pattern = /image-*/;
			if (!file.type.match(pattern)) {
				setHasError("Please upload photo of only allowed file types")
				setAnchorEl(null);
				return;
			} else if (file.size > Config.IMAGE_MAX_SIZE) {
				setHasError("File size should be less than 100 KB");
				setAnchorEl(null);
			} else if (file.size <= Config.IMAGE_MIN_SIZE) {
				setHasError("File size should be more than 20 KB");
				setAnchorEl(null);
			} else {
				setImage(Url);
				setFile(file);
				setAnchorEl(null);
			}
		}
	}

	const handleFileInputClick = () => {
		fileInputRef.current.click();
	};

	const onRemovephoto = () => {
		setImage(null);
		setFile(null);
		setImageCleared(true);
		setAnchorEl(null);
		setHasError("");
	};

	const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => UserService.getCurrentUserFromLocalStorage());

	return (
		<PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className={IsMobileDevice ? 'h-fill' : 'h-auto'}>
			<div className={`w-fill ${IsMobileDevice ? "d-flex flex-direction h-fill o-hidden" : "h-fill"}`}>
				{IsMobileDevice && <> {showEditProfile ?
					<div className='bg-transparent d-flex w-fill p-1'>
						<span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => handleCloseEditProfile(false)} /></span>
						<span className={`h3-semibold d-inline-flex color-primary-accent mr-auto`}>{pageTitles.EDIT_PROFILE}</span>
					</div> :
					<PageHeader
						HeaderText={pageTitles.PROFILE}
						HideSearch={true}
						ShowFilterIcon={false} />
				}</>}
				<div className={`w-fill ${IsMobileDevice ? 'flex-1 px-1 pt-1 o-y-auto' : 'h-p-100 d-flex w-p-100 mx-auto justify-center align-center'} ${IsDarkMode ? "bg-color-primary-background" : "bg-color-profile-primary-background"} `} style={IsMobileDevice ? { minHeight: 0 } : undefined}>
					<div className={`settings-mobile-paper-border ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"} profile-border br-3 ${IsMobileDevice ? "w-p-90 mx-auto h-p-40 mb-2" : ` w-p-20 ${(UserService.hasUserRole() || UserService.hasManagerRole()) ? "h-p-66" : "h-p-60"} mr-2 min-w-30 max-w-30`}`}>
						<div className="w-p-100 h-p-52 d-flex align-center justify-flex-end flex-direction p-relative">
							{(image) ?
								<Avatar
									Name={Profile.FullName}
									Size={IsMobileDevice ? 88 : 140}
									ImgSrc={image}
								/>
								:
								<Avatar
									Name={Profile.FullName}
									Size={IsMobileDevice ? 88 : 140}
								/>
							}
							{IsMobileDevice && !showEditProfile && <ButtonComponent
								buttonProps={{ tabIndex: 3 }}
								Variant={
									LoadingProfile ? "disabled-btn" : "primary-btn"
								}
								ClassName={`c-pointer color-profile-changepassword-box-border primary-btn d-flex p-absolute r-2 t-0`}
								OnClick={handleOpenEditProfile}
								Icon={EditProfileIcon}
								ButtonLabel=""
							/>}
							{showEditProfile && <>
								<Badge
									badgeContent={
										<button
											tabIndex={3}
											className=""
											onClick={handleClickmenu}
										>
											<ProfileImageIcon role="button" />
										</button>
									}
									anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
									classes={{ anchorOriginBottomRightRectangular: `${IsMobileDevice ? "b-1 l-1" : "b-2 l-4"} ` }}
								></Badge>
								<Menu
									// getContentAnchorEl={null}
									id="simple-menu"
									anchorEl={anchorEl}
									open={Boolean(anchorEl)}
									onClose={handleClosemenu}
									PaperProps={{
										className: "box-shadow-none"
									}}
								>
									<MenuItem className={"c-pointer"} classes={{ root: "m-menuitem-min-height" }} onClick={handleFileInputClick} >
										<span className={`color-profile-profile-heading ${IsMobileDevice ? "h2" : "h4-regular"}`}>
											{!image ?
												<UploadIcon className={"mr-1"} />
												:
												<ChangeProfileIcon className={"mr-1"} />}
										</span>
										<span className={`color-profile-profile-heading ${IsMobileDevice ? "h2" : "h4-regular"}`}	>
											<label htmlFor={"Upload" + imageReferenceId} onClick={(e) => e.stopPropagation()}>
												<span className={"h4-regular color-menu-list-font-color c-pointer"}> {!image ? ActionLabels.UPLOAD_PHOTO : ActionLabels.CHANGE_PHOTO}</span>
											</label>
											<input
												id={"Upload" + imageReferenceId}
												accept="image/*"
												className={"d-none"}
												multiple
												type="file"
												onChange={onImagechange}
												ref={fileInputRef}
											/>
										</span>
									</MenuItem>
									<MenuItem
										onClick={onRemovephoto}
										classes={{ root: `${IsMobileDevice && "minh-0"}` }}
										className={`${!image ? "disabled" : "c-pointer"}`}
									>
										<span
											className={`${!image ? `disabled  ${IsMobileDevice ? "h2" : "h4-regular"}`
												: `color-profile-profile-heading  ${IsMobileDevice ? "h2" : "h4-regular"}`}`} >
											{!image ?
												<RemovePhotoIcon className={"mr-1"} /> : <RemoveIcon className={"mr-1"} />
											}
										</span>
										<span
											className={`${!image ? `disabled color-secondary-light ${IsMobileDevice ? "h2" : "h4-regular"}`
												: `color-profile-profile-heading  ${IsMobileDevice ? "h2" : "h4-regular"}`}`}>
											{ActionLabels.REMOVE_PHOTO}
										</span>
									</MenuItem>
								</Menu>
							</>
							}
							<div className="w-p-100 h-3 color-primary-danger h6-medium d-flex justify-center align-center">{hasError}</div>
						</div>
						<div className="w-p-100 h-p-47 d-flex flex-direction justify-center align-center">
							<div className={`h-p-30 color-login-title t-align-center ${Profile.FullName.length > 50 ? 'h5-medium d-flex flex-wrap px-7' : Profile.FullName.length > 20 ? 'h4-medium d-flex flex-wrap px-7' : 'h2-medium'}`}>
								{UtilityService.trimMessage(Profile.FullName, 15)}
							</div>
							<div className="h-p-33 h5-regular color-send-msg-title pt-1">
								{OrgName}
							</div>
							<div className=" h-p-15 h4-semibold color-grid-header-font-color" >
								Primary Phone Number
							</div>
							<div className="h-p-40 h2-semibold color-phone-number" >
								{UtilityService.maskPhoneNumberOnLength(Profile.PhoneNumber || '')}
							</div>
						</div>
						<div className="w-p-100 h-p-60">

						</div>
					</div>
					<div className={`settings-mobile-paper-border ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-secondary"} profile-border br-3 ${IsMobileDevice ? "w-p-90 mx-auto d-flex mb-2" : `w-p-50 ${UserService.hasUserRole() || UserService.hasManagerRole() ? "h-p-66" : "h-p-60"} min-w-60 max-w-100 o-y-hidden d-flex flex-direction`}`}>
						{!IsMobileDevice && <div className="h-9 profile-divider d-flex justify-between color-login-subtitle px-4 mt-1">
							<div className="h2-semibold mr-auto h-p-100 d-flex align-center">
								Profile Details
							</div>
							<div className="ml-auto h-p-100 d-flex align-center">
								{!showEditProfile ? <ButtonComponent
									buttonProps={{ tabIndex: 3 }}
									Variant={
										LoadingProfile ? "disabled-btn" : "primary-btn"
									}
									ClassName={`c-pointer ${IsDarkMode ? "" : "color-profile-changepassword-box-border"} primary-btn d-flex ml-auto ${IsMobileDevice ? "h2 mx-auto mt-1" : "h5-regularr"
										}`}
									OnClick={handleOpenEditProfile}
									Icon={EditProfileIcon}
									ButtonLabel="Edit Profile"
								/>
									:
									<>
										<ButtonComponent
											buttonProps={{ tabIndex: 7 }}
											Variant="secondary-btn-small"
											ClassName={`c-pointer  mr-1`}
											OnClick={() => handleCloseEditProfile(false)}
											ButtonLabel="Cancel"
										/>
										<ButtonComponent
											buttonProps={{ tabIndex: 6 }}
											Variant={!(errors.FirstName || errors.LastName || hasError.length !== 0) ? "primary-btn-small" : "disabled-btn-small"}
											ClassName={`c-pointer w-space px-4`}
											Type={"submit"}
											ButtonLabel="Save"
											Loading={isLoading}
											OnClick={onSubmit}
										/>
									</>
								}
							</div>
						</div>
						}
						<div className="border-top"></div>
						<div className="w-p-100 h-p-100">
							<div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 mt-2 pl-4"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									First Name
								</div>
								<div className={` ${IsMobileDevice ? "w-p-95 h-5 d-flex align-center h4-regular" : "w-p-50 h4-regular"} color-login-subtitle`}>
									{showEditProfile ?
										<>
											<TextField
												autoFocus
												fullWidth
												name="FirstName"
												placeholder="First Name"
												size="small"
												variant="outlined"
												InputProps={{
													classes: {
														input: `profile-edit-input color-profile-textfield-content ${IsMobileDevice ? "h3-medium" : 'h4-regular'}`,
													},
												}}
												className="br-2 my-auto"
												onChange={(e) => { handleChange(e.target.name, e.target.value); setFirstName(e.target.value) }
												}
												defaultValue={firstName}
												inputProps={{ tabIndex: 4 }}
											/>
										</> :
										<div className="br-2 h-p-100 d-flex align-center"> {UtilityService.trimMessage(Profile.FirstName, 20)} </div>
									}
								</div>
								{
									IsMobileDevice && <FormHelperText className=" footnote-regular color-primary-danger t-align-right ml-auto pr-3">
										{errors.FirstName}
									</FormHelperText>
								}
							</div>
							{!IsMobileDevice && <div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center pl-4 h-2"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-2 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								</div>
								<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center" : "w-p-50"} color-login-subtitle h4-medium`}>
									<FormHelperText className=" footnote-regular color-primary-danger t-align-right">
										{errors.FirstName}
									</FormHelperText>
								</div>
							</div>
							}
							<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center mt-1 h-5 pl-4"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									Last Name
								</div>
								<div className={` ${IsMobileDevice ? "w-p-95 h-5 d-flex align-center h4-regular" : "w-p-50 h4-regular"} color-login-subtitle`}>
									{showEditProfile ?
										<>
											<TextField
												fullWidth
												name="LastName"
												placeholder="Last Name"
												size="small"
												variant="outlined"
												InputProps={{
													classes: {
														input: `profile-edit-input color-profile-textfield-content ${IsMobileDevice ? "h3-medium" : 'h4-regular'}`,
													},
												}}
												className="br-2 my-auto"
												onChange={(e) => { handleChange(e.target.name, e.target.value); setLastName(e.target.value) }
												}
												defaultValue={lastName}
												inputProps={{ tabIndex: 4 }}
											/>
										</> :
										<div className="br-2 h-p-100 d-flex align-center"> {UtilityService.trimMessage(Profile.LastName, 20)} </div>
									}
								</div>
								{
									IsMobileDevice && <FormHelperText className=" footnote-regular color-primary-danger t-align-right ml-auto pr-3">
										{errors.LastName}
									</FormHelperText>
								}
							</div>
							{!IsMobileDevice && <div className={` d-flex  ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center pl-4 h-2"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-2 d-flex align-end" : "w-p-30"} h5-medium color-profile-name-field`}>
								</div>
								<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center" : "w-p-50"} color-login-subtitle h4-medium`}>
									<FormHelperText className=" footnote-regular color-primary-danger t-align-right">
										{errors.LastName}
									</FormHelperText>
								</div>
							</div>
							}
							<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 pl-4 mb-2"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									Email
								</div>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-center mb-1 h4-regular" : "w-p-60 h4-regular"} color-login-subtitle `}>
									{Profile.Email}
								</div>
							</div>
							<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 pl-4 mb-1"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									Organization Name
								</div>
								<div className={` ${IsMobileDevice ? "w-p-95 h-3 d-flex align-center mb-1 h4-regular" : "w-p-50 h4-regular"} color-login-subtitle`}>
									<div className="br-2 h-p-100 d-flex align-center"> {OrgName} </div>
								</div>
							</div>
							<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 mb-2 pl-4"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									Role
								</div>
								<div className={` ${IsMobileDevice ? "w-p-100 h-4 d-flex align-center h4-regular" : "w-p-50 h4-regular"} color-login-subtitle `}>
									{Profile.RoleID === Role.SYSTEM_ADMIN.toString() ? RolesLabel.SYSTEM_ADMIN : Profile.RoleID === Role.ORGANIZATION_ADMIN.toString() ? RolesLabel.ORGANIZATION_ADMIN : Profile.RoleID === Role.MANAGER.toString() ? RolesLabel.Manager : RolesLabel.USER}
								</div>
							</div>
							{(UserService.hasUserRole() || UserService.hasManagerRole()) && (
								<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : `w-p-90 align-center h-5 pl-4 pb-1 ${Profile.SecondaryPhoneNumbers.length > 2 && "o-y-scroll"} `}`}>
									<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
										Switchable Phone Number(s)
									</div>
									<div className={` ${IsMobileDevice ? "w-p-95 h-3 h4-regular mb-1 o-y-scroll" : "w-p-60 d-flex flex-wrap h4-regular "} color-login-subtitle`}>
										{Profile.SecondaryPhoneNumbers?.map((x, index) => (
											<div key={index} className={`${IsMobileDevice ? " br-2  d-flex align-center" : "br-2 h-p-100 d-flex align-center mt-1 mr-1"}`}> {UtilityService.maskPhoneNumber(x.phoneNumber)}</div>))}
									</div>
								</div>)}
							<div className={` d-flex ${IsMobileDevice ? "flex-direction align-start pl-2 mt-1" : "w-p-90 align-center h-5 mb-2 pl-4"}`}>
								<div className={` ${IsMobileDevice ? "w-p-100 h-3 d-flex align-end" : "w-p-30"} h4-medium color-login-subtitle`}>
									{Profile?.phoneNumberGroups?.length > 1 ? pageTitles.LINE_GROUPS : pageTitles.LINE_GROUPS.replace("s", "")}
								</div>
								<div className={` ${IsMobileDevice ? "w-p-100 h-4 d-flex align-center h4-regular" : "w-p-50 h4-regular"} color-login-subtitle `}>
									{Profile.phoneNumberGroups?.map((x, index) => (
										<div key={index} className={`${IsMobileDevice ? " br-2  d-flex align-center" : "br-2 h-p-100 d-flex align-center  mr-1"}`}> {x.name}</div>))}								</div>
							</div>
						</div>
					</div>
					{(IsMobileDevice && showEditProfile) &&
						<div className="w-p-90 d-flex justify-between mx-auto mt-2 mb-2 pb-6">
							<ButtonComponent
								buttonProps={{ tabIndex: 7 }}
								Variant="secondary-btn-small"
								ClassName={`c-pointer mr-2 w-p-45`}
								OnClick={() => handleCloseEditProfile(false)}
								ButtonLabel="Cancel"
							/>
							<ButtonComponent
								buttonProps={{ tabIndex: 6 }}
								Variant={!(errors.FirstName || errors.LastName || hasError.length !== 0) ? "primary-btn-small" : "disabled-btn-small"}
								ClassName={`c-pointer w-space w-p-45`}
								Type={"submit"}
								ButtonLabel="Save"
								Loading={isLoading}
								OnClick={onSubmit}
							/>
						</div>
					}
				</div>
			</div>
		</PullToRefresh>

	);
}

export default ProfileComponent;